import axios from 'axios';
import { ElMessageBox, ElMessage } from 'element-plus';
import store from '@/store';
import { getToken } from '@/utils/auth';
import { config } from '@/utils/config';
import router from '@/router';
// import config from '../../public/config.json';

// 登录提示框是否已弹出，避免并发请求重复弹出多个提示框
let loginConfirmShowing = false;

// create an axios instance
const service = axios.create({
    baseURL: config().baseServer, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 120 * 1000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['Access-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Access-Token'] = getToken();
        }
        config.headers['Point-Id'] = localStorage.getItem('pointId');
        config.headers['Access-Origin'] = window.location.origin;
        config.headers['Access-Host'] = window.location.host;
        return config;
    },
    error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;

        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0) {
            // 10 您的账号已登出或状态过期，请重新登录
            // 11 您访问的内容需要登录才能查看，请先登录系统
            // 12 您正在访问未经授权的内容，具体请联系内容发布方
            switch (res.code) {
                case 10:
                case 11:
                    {
                        // 未登录用户访问受限内容，弹出登录提示框，由用户选择是否马上登录
                        // 并发请求时只弹一次登录提示框
                        if (!loginConfirmShowing) {
                            loginConfirmShowing = true;
                            ElMessageBox.confirm(res.msg || '您访问的内容需要登录才能查看，请先登录系统', '请登录', {
                                confirmButtonText: '马上登录',
                                cancelButtonText: '短暂停留',
                                type: 'warning'
                            }).then(() => {
                                store.dispatch('user/resetToken').then(() => {
                                    // location.reload();
                                    router.push(`/login?redirect=` + location.pathname);
                                });
                            }).finally(() => {
                                // 提示框关闭后复位，后续请求可再次提示
                                loginConfirmShowing = false;
                            });
                        }
                    }
                    break;
                case 12:
                    {
                        // http://localhost:8080/collected/262975768051580929/275951135947227136
                        router.push(`/unauthorized`);

                        // 提示信息，可自行选择是否登录
                        // ElMessageBox.confirm(res.msg, '登出确认', {
                        //     confirmButtonText: '重新登录',
                        //     cancelButtonText: '短暂停留',
                        //     type: 'warning'
                        // }).then(() => {
                        //     // router.push({ path: `/login?redirect=${redirect}`, params: {} });
                        //     store.dispatch('user/resetToken').then(() => {
                        //         // location.reload();
                        //         router.push(`/login?redirect=` + location.pathname);
                        //     });
                        // });
                    }
                    break;
                default:
                    {
                        // 仅提示信息
                        ElMessage({
                            message: res.msg || 'Error',
                            type: 'error',
                            duration: 5 * 1000
                        });
                    }
                    break;
            }
            console.log(`请求回复异常：${res.message}`);
            return Promise.reject(new Error(res.message || 'Error'));
        } else {
            return res;
        }
    },
    error => {
        console.log('err' + error); // for debug
        ElMessage({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;
